import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEVolveLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 79,
	height: 14,
	viewBox: "0 0 79 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3731_47766)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0.251221H10.4061V2.866H2.88078V5.16166L8.16426 5.17644V7.70861H2.88078V10.7547H10.4236V13.3756H0V0.251221Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.3262 6.80522C26.3262 2.97739 29.3992 0 33.4075 0C37.4158 0 40.4915 2.97739 40.4915 6.80522C40.4915 10.633 37.4184 13.6313 33.4075 13.6313C29.3966 13.6313 26.327 10.633 26.327 6.80522H26.3262ZM37.5985 6.81131C37.5985 4.39739 35.7176 2.68522 33.4014 2.68522C31.0852 2.68522 29.2043 4.39652 29.2043 6.81131C29.2043 9.22609 31.0817 10.94 33.4014 10.94C35.7211 10.94 37.5985 9.2287 37.5985 6.81131V6.81131Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.3124 0.251221H46.2072L46.1923 10.7521H52.8664V13.3695H43.3115V0.251221H43.3124Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.6416 0.251221H54.8659L58.9799 8.40513L63.1245 0.251221H66.2894L59.0157 13.9364L51.6416 0.251221Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M67.8887 0.251221H78.2948V2.866H70.7695V5.16166L76.0529 5.17644V7.70861H70.7695V10.7547H78.3132V13.3756H67.8895V0.251221H67.8887Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.3268 0.251221L26.214 0.462525L25.9344 0.988612H25.9335L19.0357 13.9356L11.6816 0.251221H12.4927L19.0357 12.4964L25.1372 0.988612H24.3401L19.0357 11.0573L13.6954 0.988612L13.3038 0.251221H15.7371L16.1121 0.988612L19.0357 6.74079L22.3316 0.251221H23.1314L19.0357 8.17992L15.308 0.988612H14.5021L19.0357 9.61905L23.5448 0.988612L23.9302 0.251221H26.3268Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3731_47766",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 78.4,
			height: 14,
			fill: "currentColor"
		})
	}) })]
});
export default SvgEVolveLogo;
